// @ts-nocheck
import {
  Box,
  Button,
  Card,
  FormControl,
  FormHelperText,
  Grid
} from '@mui/material';
import { StyledAsterisk } from 'component/commonComponents/Textbox/Textbox.style';
import PropTypes from 'prop-types';
import React, { memo, useState } from 'react';
import '../deliveryCardComponent/deliveryCard.scss';
import PickupLocationDialog from './pickupLocationDialog';
import defaultProps from './defaultProps';
import { StyledPickupLocationCard } from './pickupLocation.style';
import parse from 'html-react-parser';

const PickupLocation = (props: any) => {
  const {
    defaultCountry,
    countryList,
    countryUserLogin,
    onChange,
    error,
    errorText,
    addressItem,
    locale,
    required,
    dataPickupLocation,
    handleChangeCountry,
    isLoading,
    isYourSelf,
    isJump,
    handleEdit
  } = props;

  const checkAddressItemHasValue = Object.keys(addressItem).length > 0;
  const [open, setOpen] = useState(false);
  const [checkFieldsInit, setCheckFieldsInit] = useState(false);
  const [address, setAddress] = useState(checkAddressItemHasValue ? addressItem : {});

  const handleClose = (address: any, isUpdateAddress = true) => {
    setOpen(false);
    if (isUpdateAddress) {
      setCheckFieldsInit(true);
      setAddress(address);
      onChange(address);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const isCheckBtnEdit = (!checkAddressItemHasValue || checkFieldsInit || (checkAddressItemHasValue && !isYourSelf));

  return (
    <StyledPickupLocationCard>
      <h5 className="heading5">{props.title}{required && <StyledAsterisk>*</StyledAsterisk>}</h5>
      <Card className="card-wrap">
        <FormControl error={error} className="uptime-delivery-card-body">
          <Grid container >
            <Grid item xs={isCheckBtnEdit ? 8 : 12}>
              {checkAddressItemHasValue || checkFieldsInit ? (
                <Box className="content-box bodyRegular">
                  <p>{parse(address?.shipping_address.replace(/\n/g, '<br>'))}</p>
                </Box>
              ) : (
                <Box className="content-box bodyRegular">
                  <p>{locale.addressType.city}</p>
                </Box>
              )}
            </Grid>

            {isCheckBtnEdit && <Grid item xs={4}>
              {
                <Button
                  className="buttonLink"
                  onClick={isJump ? handleEdit : handleClickOpen}
                >
                  {checkFieldsInit || checkAddressItemHasValue ? locale.editAddress : locale.addAddress}
                </Button>
              }
            </Grid>}
            
          </Grid>

          {error && <FormHelperText id="my-helper-text">{errorText}</FormHelperText>}

        </FormControl>
      </Card>

      <PickupLocationDialog
        open={open}
        onClose={handleClose}
        countryList={countryList}
        addressAfterSave={address}
        countryUserLogin={countryUserLogin?.toLowerCase()}
        locale={locale}
        dataPickupLocation={dataPickupLocation}
        isLoading={isLoading}
        handleChangeCountry={handleChangeCountry}
        isYourSelf={isYourSelf}
        defaultCountry={defaultCountry}
      />

    </StyledPickupLocationCard>
  );
};

PickupLocation.propTypes = {
  isLoading: PropTypes.bool,
  title: PropTypes.string,
  defaultCountry: PropTypes.string,
  onChange: PropTypes.func,
  handleChangeCountry: PropTypes.func,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  countryList: PropTypes.array,
  countryUserLogin: PropTypes.string,
  addressItem: PropTypes.object,
  locale: PropTypes.object,
  required: PropTypes.bool,
  isYourSelf: PropTypes.bool,
  isJump: PropTypes.bool,
  dataPickupLocation: PropTypes.array,
  handleEdit: PropTypes.func,
};

PickupLocation.defaultProps = {
  ...defaultProps,
};

export default memo(PickupLocation);
